import { render, staticRenderFns } from "./PublicationMunMehList.vue?vue&type=template&id=22cf1f4e&"
import script from "./PublicationMunMehList.vue?vue&type=script&lang=js&"
export * from "./PublicationMunMehList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports